import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gc_button = _resolveComponent("gc-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_gc_button, {
      secondary: "",
      label: $props.declineAccessLinkLabel,
      url: $props.declineAccessLink,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($options.handleClick($event, false)), ["prevent"]))
    }, null, 8, ["label", "url"]),
    _createVNode(_component_gc_button, {
      color: "primary",
      label: $props.approveAccessLinkLabel,
      url: $props.approveAccessLink,
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($options.handleClick($event, true)), ["prevent"]))
    }, null, 8, ["label", "url"])
  ]))
}